import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as ColorPaletteActions from './color-palette.actions';
import * as OrgActions from '../org/org.actions';
import { AccountClientService } from '@mode/shared/data-access-webapp';

@Injectable()
export class ColorPaletteEffects {
  loadColorPalettes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ColorPaletteActions.loadColorPalettes),
      switchMap((action) => this.client.getColorPalettes(action.username)),
      map((palettes) =>
        ColorPaletteActions.loadColorPalettesSuccess({
          palettes,
        })
      ),
      catchError((error) => of(ColorPaletteActions.loadColorPalettesFailure({ error })))
    );
  });

  loadColorPalettesWithReportOwner$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrgActions.loadReportOwnerSuccess),
      filter((action) => action.org.isMember || action.org.user), // can't pull color palettes of non-member orgs
      switchMap((action) => this.client.getColorPalettes(action.org.username)),
      map((palettes) =>
        ColorPaletteActions.loadColorPalettesSuccess({
          palettes,
        })
      ),
      catchError((error) => of(ColorPaletteActions.loadColorPalettesFailure({ error })))
    );
  });

  constructor(private actions$: Actions, private client: AccountClientService) {}
}
